export const QUERY_KEYS = {
  AFFILIATE_PPP_SUB_ID_1: 'subId1',
  AFFILIATE_PPP_SUB_ID_2: 'subId2',
  AFFILIATE_PPP_SUB_ID_3: 'subId3',
  AFFILIATE_PPP_SUB_ID_4: 'subId4',
  AFFILIATE_PPP_SUB_ID_5: 'subId5',
  AFFILIATE_PPP_STREAM_ID: 'st',
  AFFILIATE_ALAN_SUB_ID_1: 'sub_id1',
  AFFILIATE_ALAN_SUB_ID_2: 'sub_id2',
  AFFILIATE_ALAN_SUB_ID_3: 'sub_id3',
  AFFILIATE_ALAN_SUB_ID_4: 'sub_id4',
  AFFILIATE_ALAN_SUB_ID_5: 'sub_id5',
  AFFILIATE_ALAN_SUB_ID_6: 'sub_id6',
  AFFILIATE_ALAN_SUB_ID_7: 'sub_id7',
  AFFILIATE_ALAN_SUB_ID_8: 'sub_id8',
  AFFILIATE_ALAN_SUB_ID_9: 'sub_id9',
  AFFILIATE_ALAN_SUB_ID_10: 'sub_id10',
  AFFILIATE_ALAN_CLICK_ID: 'alan_click_id',
  AFFILIATE_ALAN_OFFER_ID: 'offer_id',
  AFFILIATE_ALAN_PARTNER_ID: 'partner_id',
  AFFILIATE_ALAN_CREATIVE_ID: 'creative_id',
  AFFILIATE_ALAN_LANDING_ID: 'landing_id',
  AFFILIATE_AFFILKA: 'stag',
} as const

export const AFFILIATE_ALAN_QUERY_KEYS = [
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_1,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_2,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_3,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_4,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_5,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_6,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_7,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_8,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_9,
  QUERY_KEYS.AFFILIATE_ALAN_SUB_ID_10,
  QUERY_KEYS.AFFILIATE_ALAN_CLICK_ID,
  QUERY_KEYS.AFFILIATE_ALAN_PARTNER_ID,
  QUERY_KEYS.AFFILIATE_ALAN_OFFER_ID,
  QUERY_KEYS.AFFILIATE_ALAN_CREATIVE_ID,
  QUERY_KEYS.AFFILIATE_ALAN_LANDING_ID,
] as const
